import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/lib/store';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuthStore();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center" data-testid="auth-loading">
        <div className="h-9 w-9 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/" replace />;
  return children;
};
